import TreatmentI from '@interfaces/patients/treatmentI';
import axiosApiInstance from '@services/custom-axios-instance';
import { generateUrl } from "@services/generateUrl/generateUrl";

export function getPatientTreatments(
    patientUsername: string
): Promise<TreatmentI[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/treatment-username/${patientUsername}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as TreatmentI[];
        });
}
export function getPatientTreatmentsWithRelatedToHormoneFilter(
    patientUsername: string,
    isRelatedToHormone: boolean
): Promise<TreatmentI[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/treatment-username/${patientUsername}/filter?isRelatedToHormone=${isRelatedToHormone}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as TreatmentI[];
        });
}
export function getPatientTreatment(treatmentId: string): Promise<TreatmentI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/treatment/${treatmentId}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as TreatmentI;
        });
}

export function postPatientTreatment(
    treatment: TreatmentI
): Promise<TreatmentI> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/emr/treatment`,
            treatment
        )
        .then((response) => {
            const data = response.data as unknown;
            return data as TreatmentI;
        });
}

export function postUpdateTreatment(treatment: TreatmentI) {
    return axiosApiInstance
        .put(
            `${generateUrl()}/emr/treatment/patient`,
            treatment
        )
        .then((response) => {
            const data = response.data as unknown;
            return data;
        });
}

export function deletePatientTreatment(treatmentId: string) {
    return axiosApiInstance
        .delete(
            `${generateUrl()}/emr/treatment/${treatmentId}`
        )
        .then((response) => {
            const data = response.data as unknown;
            return data;
        });
}
